import { AxiosError } from 'axios';

/** Extract error detail message from an unknown catch value. */
export function getErrorDetail(error: unknown, fallback: string): string {
  if (error instanceof AxiosError) {
    return error.response?.data?.detail ?? fallback;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallback;
}

/** Extract validation_errors array from an Axios error response. */
export function getValidationErrors(error: unknown): string[] | null {
  if (error instanceof AxiosError) {
    return error.response?.data?.validation_errors ?? null;
  }
  return null;
}
